import { combineReducers } from 'redux'
import { createRouterReducer } from 'lib/routing/appRouting'

import uiReducer from './ui'
import giftCardReducer from './giftCard'
import redeemedGiftCardsReducer from './redeemedGiftCards'
import offerReducer from './offer'
import offerComparisonReducer from './offerComparison'
import cartOfferComparisonReducer from './cartOfferComparison'
import orderReducer from './order'
import ordersReducer from './orders'
import authReducer from './auth'
import geoReducer from './geo'
import routeHistoryReducer from './routeHistory'
import analyticsReducer from './analytics'
import contentReducer from './content'
import flightsReducer from './flights'
import insuranceReducer from './insurance'
import passportCardInsuranceReducer from './passportCardInsurance'
import calendarReducer from './calendar'
import systemReducer from './system'
import optimizelyReducer from './optimizely'
import chertoReducer from './cherto'
import destinationReducer from './destination'
import destinationProductPageReducer from './destinationProductPage'
import checkoutReducer from './checkout'
import experiencesReducer from './experiences'
import cruisesReducer from './cruises'
import tourReducer from './tours'
import tripPlannerReducer from 'tripPlanner/reducers'
import referReducer from './refer'
import marketingReducer from './marketing'
import reviewReducer from './review'
import utmReducer from './utm'
import recommendationsReducer from './recommendations'
import wlSubscriptionsReducer from './WLSubscriptions'
import leSubscriptionsReducer from './LESubscriptions'
import userTravelPreferencesReducer from './userTravelPreferences'
import carHireReducer from './carHire'
import stickPromptCardReducer from './stickyPromptCard'
import luxPlusReducer from './luxPlus'
import bookingProtectionReducer from './bookingProtection'
import agentHubReducer from './agentHub'
import sherlogReducer from './sherLog'
import supportAssistantReducer from './supportAssistantActionReducer'
import securePaymentReducer from './securePayment'
import type { History } from 'history'
import loyaltyStateReducer from './loyaltyStateReducer'
import merchandiseStateReducer from './merchandiseStateReducer'
import searchReducer from './search'
import paymentScheduleReducer from './paymentSchedule'
import flightAndHotelBundleReducer from './flightAndHotelBundle'
import wrappedReducer from './wrapped'

export default (history: History) => combineReducers({
  agentHub: agentHubReducer,
  analytics: analyticsReducer,
  auth: authReducer,
  bookingProtection: bookingProtectionReducer,
  calendar: calendarReducer,
  carHire: carHireReducer,
  cartOfferComparison: cartOfferComparisonReducer,
  cherto: chertoReducer,
  checkout: checkoutReducer,
  system: systemReducer,
  content: contentReducer,
  cruise: cruisesReducer,
  destination: destinationReducer,
  destinationProductPage: destinationProductPageReducer,
  experience: experiencesReducer,
  flights: flightsReducer,
  geo: geoReducer,
  giftCard: giftCardReducer,
  redeemedGiftCards: redeemedGiftCardsReducer,
  insurance: insuranceReducer,
  passportCardInsurance: passportCardInsuranceReducer,
  leSubscriptions: leSubscriptionsReducer,
  luxPlus: luxPlusReducer,
  loyalty: loyaltyStateReducer,
  flightAndHotelBundle: flightAndHotelBundleReducer,
  marketing: marketingReducer,
  merchandise: merchandiseStateReducer,
  offer: offerReducer,
  offerComparison: offerComparisonReducer,
  optimizely: optimizelyReducer,
  order: orderReducer,
  orders: ordersReducer,
  recommendations: recommendationsReducer,
  refer: referReducer,
  review: reviewReducer,
  routeHistory: routeHistoryReducer,
  router: createRouterReducer(history),
  search: searchReducer,
  sherLog: sherlogReducer,
  stickyPromptCard: stickPromptCardReducer,
  supportAssistant: supportAssistantReducer,
  tour: tourReducer,
  tripPlanner: tripPlannerReducer,
  ui: uiReducer,
  utm: utmReducer,
  wlSubscriptions: wlSubscriptionsReducer,
  securePayment: securePaymentReducer,
  userTravelPreferences: userTravelPreferencesReducer,
  paymentSchedule: paymentScheduleReducer,
  wrapped: wrappedReducer,
})
